var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrowseFilesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8335 1.66675H3.00016C2.55814 1.66675 2.13421 1.84234 1.82165 2.1549C1.50909 2.46746 1.3335 2.89139 1.3335 3.33341V16.6667C1.3335 17.1088 1.50909 17.5327 1.82165 17.8453C2.13421 18.1578 2.55814 18.3334 3.00016 18.3334H13.0002C13.4422 18.3334 13.8661 18.1578 14.1787 17.8453C14.4912 17.5327 14.6668 17.1088 14.6668 16.6667V7.50008M8.8335 1.66675L14.6668 7.50008M8.8335 1.66675L8.8335 7.50008H14.6668",
    stroke: "#3474E0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowseFilesIcon);
export default __webpack_public_path__ + "static/media/browse_files_icon.640ca384a1d62fbf5dafea0507b4ab43.svg";
export { ForwardRef as ReactComponent };